import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Project toevoegen", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Jouw projecten", -1)

import { EyeOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import axios from 'axios'
import { ref } from 'vue'
import { ls } from '@/ls'
import { useRouter } from 'vue-router'
import { notification } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeRegistrationProjects',
  setup(__props) {

const router = useRouter()
const loading = ref(false)
const projects = ref([])
const timeRegistrationProjects = ref<{ id:number, name:string, reference:string, city:string }[]>(ls.get('timeRegistrationProjects') || [])
const showProjectsModal = ref(false)
let projectTimer = 0
const columns = [
  {
    title: 'Project',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Plaats',
    dataIndex: 'city',
    key: 'city'
  },
  {
    title: 'Actie\'s',
    dataIndex: 'actions',
    key: 'actions'
  }
]

const modalColumns = [
  {
    title: 'Project',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Actie\'s',
    dataIndex: 'actions',
    key: 'actions'
  }
]

function toggleProjectsModal () : void {
  showProjectsModal.value = !showProjectsModal.value
}

function searchProjects (val:string) : void {
  if (val.length >= 3) {
    clearTimeout(projectTimer)
    loading.value = true
    projectTimer = setTimeout(() => {
      axios.get(process.env.VUE_APP_API_URL + '/projects?filter[search]=' + val + '&sort=name').then((res) => {
        projects.value = res.data.data
      }).finally(() => {
        loading.value = false
      })
    }, 500)
  } else {
    projects.value = []
  }
}

function addPersonalProject (id:number) : void {
  projects.value.forEach((p:{ id:number, name:string, reference:string, city:string }) => {
    if (p.id === id) {
      timeRegistrationProjects.value.push({ id: p.id, name: p.name, reference: p.reference, city: p.city })
      ls.set('timeRegistrationProjects', timeRegistrationProjects.value)
      toggleProjectsModal()

      notification.success({
        message: 'Project toegevoegd.',
        description: 'Het project ' + p.name + ' is succesvol toegevoegd.',
        duration: 5
      })

      axios.post(process.env.VUE_APP_API_URL + '/users/constructionSiteApp/settings', {
        settingName: 'timeRegistrationProjects',
        settingValue: timeRegistrationProjects.value
      })
    }
  })
}

function removePersonalProject (index:number) : void {
  timeRegistrationProjects.value.splice(index, 1)
  ls.set('timeRegistrationProjects', timeRegistrationProjects.value)

  axios.post(process.env.VUE_APP_API_URL + '/users/constructionSiteApp/settings', {
    settingName: 'timeRegistrationProjects',
    settingValue: timeRegistrationProjects.value
  })
}

function onRowClick (rowData:{ id:number }) : { onClick: () => void } {
  return {
    onClick: () => {
      router.push({ name: 'ProjectTimesheets', params: { projectId: rowData.id.toString() } })
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { title: "Uren- en materiaalregistratie" }, {
            extra: _withCtx(() => [
              _createVNode(_component_a_button, { onClick: toggleProjectsModal }, {
                default: _withCtx(() => [
                  _createTextVNode("Projecten beheren")
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                columns: columns,
                "data-source": timeRegistrationProjects.value,
                pagination: false,
                rowKey: "id",
                customRow: onRowClick
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.key === 'name')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(record.name) + " (" + _toDisplayString(record.reference) + ") ", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.key === 'city')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(record.city), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.key === 'actions')
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 2,
                        style: {"margin-right":"4px"},
                        onClick: ($event: any) => (_unref(router).push({ name: 'ProjectTimesheets', params: { projectId: record.id } }))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(EyeOutlined))
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data-source"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_modal, {
            title: "Jouw projecten wijzigen",
            visible: showProjectsModal.value,
            footer: null,
            onCancel: toggleProjectsModal
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createVNode(_component_a_select, {
                        placeholder: "Begin met typen om te zoeken..",
                        "default-active-first-option": false,
                        "filter-option": false,
                        fieldNames: { label: 'name', value: 'id' },
                        loading: loading.value,
                        options: projects.value,
                        onSearch: searchProjects,
                        onChange: addPersonalProject,
                        "show-search": ""
                      }, null, 8, ["loading", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createVNode(_component_a_table, {
                        columns: modalColumns,
                        "data-source": timeRegistrationProjects.value,
                        pagination: false
                      }, {
                        bodyCell: _withCtx(({ column, record, index }) => [
                          (column.key === 'name')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(record.name) + " (" + _toDisplayString(record.reference) + ") ", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.key === 'actions')
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 1,
                                onClick: ($event: any) => (removePersonalProject(index))
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_unref(DeleteOutlined))
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["data-source"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["visible"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})